import { TObject } from "../../common/TObject";
import { iData, iDataResult } from "./Data";

export class Icons extends TObject implements iData {
  crmmap: any = null;
  apicall: string = "/icons";
  cache: any = false;
  constructor(crmmap) {
    super(crmmap);
    this.crmmap = crmmap;
  }

  get() {
    return new Promise<iDataResult>((resolve) => {
      if (this.cache) {
        return resolve(this.cache);
      }
      return this.crmmap.APICall(this.apicall).then((data) => {
        this.cache = data.data;
        this.trigger("refreshed", this.cache);
        return resolve(this.cache);
      });
    });
  }

  invaledate() {
    this.cache = false;
    this.trigger("invaledate");
  }

  OnIconsChanged = (callback) => {
    $(document).bind("CRMAMP.Icons.onChanged", callback);
  };

  Icons: any[] = [];

  LoadIcons = (callback) => {
    if (this.Icons.length >= 0) return false;
    return this.CRMMap().APICall("icons", function (data, api) {
      api.Icons = [];
      api.IconDefault = data.data[0][0];
      data.data.forEach(function (element, index) {
        api.Icons[element[0]] = "images/" + element[1];
      });

      if (typeof callback === "function") {
        callback();
      }

      $(document).trigger("CRMAMP.Icons.onChanged");
    });
  };

  IconAddFromLibrary = (named, callback) => {
    this.CRMMap().APICall(
      "icons/addfromlibrary/" + named,
      function (data, api) {
        if (typeof callback === "function") {
          callback();
        }

        $(document).trigger("CRMAMP.Icons.onChanged");
      }
    );
  };

  DeleteIconById = (id, callback) => {
    this.CRMMap().APICall(
      "icons/" + id,
      function (data, api) {
        delete api.Icons[id];

        if (typeof callback === "function") {
          callback();
        }

        $(document).trigger("CRMAMP.Icons.onChanged");
      },
      "DELETE"
    );
  };
}
